<script>
import VueApexCharts from "vue-apexcharts";
import i18n from "@/plugins/i18n";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      series: [0],
      chartHeight: "300px",
      chartOptions: {
        chart: {
          height: 150,
          type: "radialBar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: "70%",
              background: "#fff",
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: "front",
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24,
              },
            },
            track: {
              background: "#fff",
              strokeWidth: "10px",
              margin: 0,
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35,
              },
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: 90,
                show: true,
                color: "#66615b",
                fontSize: "16px",
                fontFamily: "Muli",
              },
              value: {
                formatter: function (val) {
                  return parseInt(val);
                },
                fontSize: "32px",
                show: true,
                color: "#66615b",
                fontFamily: "Muli",
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 0.5,
            gradientToColors: ["#023047"],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
        labels: [i18n.t('su1Results.resultsPage.graph.dashboard')],
      },
    };
  },
  created() {
    this.updateChartHeight();
    window.addEventListener("resize", this.updateChartHeight);
  },
  methods: {
    updateChartHeight() {
      if (window.innerWidth < 768) {
        this.chartHeight = "50px";
      } else if (window.innerWidth < 992) {
        this.chartHeight = "100px";
      } else {
        this.chartHeight = "200px";
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateChartHeight);
  },
};
</script>

<template>
  <div id="chart">
    <apexchart type="radialBar" :height="chartHeight" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<style scoped>
#chart {
  width: 100%;
}
</style>